import React, { Fragment, useEffect } from 'react'
import { compose } from 'recompose'
import { useTheme, withStyles, Grid, Typography, Button, Paper, CircularProgress } from '@material-ui/core'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import Stepper from '../../../components/StepperV2'
import { withRouter } from 'react-router'
import { getTeamBackgroundByEncryptedLink, getTeamLogoByEncryptedLink, getOwnerMFAState, getCreatorInfoByEncryptedLink, getRegistrationStatus, setupPassword } from '../../../redux/actions'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, passwordMatch, passwordStrength, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector, ownerMFAStateSelector, creatorInfoSelector, registrationStatusSelector, registrationIsSavingSelector } from '../../../redux/selectors'
import translations from '../../../utilties/languages/locales'
import locale2 from 'locale2'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import CalmButton from '../../../components/CalmButton'
import FormPassword from '../../../components/FormPassword'

const formName = 'register';
const requiredValidator = required
const emailValidator = email
const passwordStrengthValidator = passwordStrength
const passwordMatchValidator = passwordMatch('password')
const selector = formValueSelector(formName)

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '6rem',
	  maxWidth: '479px',
	  width: '90%',
	  margin: '0 auto',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem',
	  }
	},
}))

const Register = ({
	handleSubmit,
	intl,
	location,
	changeEmail,
	changeLanguage,
	setupPassword,
	email,
	teamBackground,
	loadTeamBackground,
	teamBackgroundIsLoading,
	teamLogo,
	teamLogoIsLoading,
	loadTeamLogo,
    ownerMFAState,
	loadOwnerMFAState,
	pristine,
    invalid,
	creatorInfo,
	getCreatorInfo,
	registrationStatus,
	getRegistrationStatus,
	isSaving
}) => {
	
	let params = queryString.parse(location.search)

	const onSubmitForm = (values) => {
		if (location && location.search) {
			setupPassword(values.email, values.password, values.language)
		}
	}
	const classes = useStyles()
    const theme = useTheme()

	const inviterText = () => {
		return creatorInfo
			? creatorInfo.teamName || `${creatorInfo.firstName} ${creatorInfo.lastName}${creatorInfo.credentials ? ', ' + creatorInfo.credentials : ''}`
			: ''
	}

	useEffect(() => {
		const values = queryString.parse(location.search)

		if (values.email) {
			changeEmail(values.email)
		}

		if (values.data) {
			getCreatorInfo(values.data)
			loadTeamBackground(values.data)
			loadTeamLogo(values.data)
            loadOwnerMFAState(values.data)
		}

		let locale = 'en';
        
		if (locale2) {
			locale = locale2.substring(0, 5)
			if (locale !== 'en-GB') {
				locale = locale2.substring(0, 2)
			}
		}

        if (!translations[locale]) {
            locale = 'en'
        }

		changeLanguage(values.language ? values.language : locale);

		getRegistrationStatus(values.email)
	}, [])

	return (
		<LoginPagesWrapper
			logoUrl={teamLogo || !teamLogoIsLoading && defaultLogo}
			backgroundUrl={teamBackground || !teamBackgroundIsLoading && defaultBackground}>
			<form onSubmit={handleSubmit(onSubmitForm)}
				data-testid='form-selfregister'
				style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '10vh auto 0', paddingBottom: '10vh' }}>
				<input id="language" name="language" type="hidden" />
				<Paper className={classes.gridStyle} elevation={2}>
					<Grid item xs={12} style={{ paddingBottom: '20px', textAlign: 'center' }}>
						<Logo />
					</Grid>
					{creatorInfo &&
						<Fragment>
							<Grid item xs={12} style={{ paddingBottom: '20px', textAlign: 'center' }}>
								<Typography variant='h3' style={{ fontWeight: '500' }}>{intl.formatMessage({ id: 'app.register.title' }).replace('%%TeamName%%', inviterText()).replace('%%Protocol%%', creatorInfo.protocolName)}</Typography>
							</Grid>
							<Grid item xs={12} sm={10} style={{ paddingBottom: '40px', paddingTop: '10px' }}>
								<Typography align='center'>
									{intl.formatMessage({ id: 'app.register.paragraph' })}
								</Typography>
							</Grid>
						</Fragment>}
					{/* <Grid item style={{ paddingBottom: '40px', paddingTop: '10px' }}>
						<Terms />
					</Grid> */}
					<Grid item xs={12} sm={10} style={{ width: '100%', paddingTop: '20px', }}>
						<FormTextField
							data-testid='form-selfregister-input-email'
							label={intl.formatMessage({ id: 'app.email' })}
							fullWidth
							type='text'
							disabled
							name='email'
							validators={[requiredValidator, emailValidator]}
							variant='filled'
							maxLength={254}
						/>
					</Grid>
					<Grid xs={12} sm={10} style={{ width: '100%' }}>
						<Typography variant='caption'>
							{intl.formatMessage({ id: 'app.passwordRequirements' })}
						</Typography>
					</Grid>
					<Grid xs={12} sm={10} style={{ width: '100%' }}>
						<FormPassword
							data-testid='form-selfregister-input-password'
							label={intl.formatMessage({ id: 'app.password' })}
							fullWidth
							name='password'
							validators={[requiredValidator, passwordStrengthValidator]}
							variant='filled'
							maxLength={99}
						/>
					</Grid>
					<Grid xs={12} sm={10} style={{ width: '100%' }}>
						<FormPassword
							data-testid='form-selfregister-input-reenter'
							label={intl.formatMessage({ id: 'app.confirmPassword' })}
							fullWidth
							name='confirmPassword'
							validators={[required, passwordMatchValidator]}
							variant='filled'
							maxLength={99}
						/>
					</Grid>
					<Grid item xs={12} sm={10} style={{ width: '100%', paddingTop: '10px', textAlign: 'center' }}>
						<Button
							data-testid="form-selfregister-button-login"
							component={Link}
							to="/auth/login"
							style={{
								color: 'black',
								letterSpacing: '1.92px',
								fontSize: '1.2rem'
							}}
							fullWidth
							variant="text"
						>
							{intl.formatMessage({ id: 'app.registration.backLinkText' })}
                        </Button>
					</Grid>
                    <div
						className="stepper-register-wrapper stepper-register-wrapper-fullwidth"
						style={{ paddingTop: '12px' }}>
                        {/* <div className="stepper-register-back">
                            {
								//<Button
								//	data-testid="form-back-button"
								//	variant='outlined'
								//	disabled={false}
								//	startIcon={<KeyboardArrowLeft />}
								//	onClick={() => history.goBack()}
								//>
								//	<Typography style={{ fontSize: '14px' }}>
								//		{intl.formatMessage({ id: 'app.general.previous' })}
								//	</Typography>
								//</Button>
							}
                        </div> */}
						<div className="stepper-register-one-button">
							{!isSaving
								? <Button
									data-testid="form-next-button"
									type='submit'
									variant='contained'
									color='primary'
									size='small'
									disabled={pristine || invalid || isSaving}
									endIcon={<KeyboardArrowRight />}
									style={{
										marginTop: '8px',
									}}
								>
									{intl.formatMessage({ id: 'app.general.next' })}
								</Button>
								: <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '10px' }}><CircularProgress size={24} /></div>
							}
                        </div>
                        <div className="stepper-register-step">
                            <Stepper stepsCount={3 + (ownerMFAState ? 1 : 0)} selectedStep={1} stepNumber={1}/>
                        </div>

                    </div>
				</Paper>
			</form>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	failed: state.auth.failedLogin,
	email: selector(state, 'email'),
	teamBackground: teamBackgroundSelector(state),
	teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state),
    teamLogo: teamLogoSelector(state),
	teamLogoIsLoading: teamLogoIsLoadingSelector(state),
    ownerMFAState: ownerMFAStateSelector(state),
	creatorInfo: creatorInfoSelector(state),
	registrationStatus: registrationStatusSelector(state),
	isSaving: registrationIsSavingSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeEmail: (email) => dispatch(change(formName, 'email', email)),
	changeLanguage: (language) => dispatch(change(formName, 'language', language)),
	setupPassword: (email, password, language) => dispatch(setupPassword(email, password, language)),
	loadTeamBackground: (data) => dispatch(getTeamBackgroundByEncryptedLink(data)),
	loadTeamLogo: (data) => dispatch(getTeamLogoByEncryptedLink(data)),
    loadOwnerMFAState: (data) => dispatch(getOwnerMFAState(data)),
	getCreatorInfo: (data) => dispatch(getCreatorInfoByEncryptedLink(data)),
	getRegistrationStatus: (email) => dispatch(getRegistrationStatus(email))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: formName
	}),
	withRouter
)

export default enhance(Register)
